enum BodyTypeEnum {
	Text = "text",
	Image = "image",
}

export default BodyTypeEnum;
